module.exports = __webpack_public_path__ + "static/optimizely-5ddc9050536d331f6297165d1ca4a1c4.jpg";